var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0733 1.67325C5.88182 1.67325 1.67328 5.88179 1.67328 11.0732C1.67328 16.2647 5.88182 20.4732 11.0733 20.4732C13.3449 20.4732 15.4283 19.6675 17.0533 18.3261L21.4267 22.6995L22.6995 21.4267L18.3261 17.0533C19.6675 15.4283 20.4733 13.3449 20.4733 11.0732C20.4733 5.88179 16.2647 1.67325 11.0733 1.67325ZM3.47328 11.0732C3.47328 6.8759 6.87594 3.47325 11.0733 3.47325C15.2706 3.47325 18.6733 6.8759 18.6733 11.0732C18.6733 15.2706 15.2706 18.6732 11.0733 18.6732C6.87594 18.6732 3.47328 15.2706 3.47328 11.0732Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1ac42b08b58e27e2d6e4041d27f53db5.svg";
export { ForwardRef as ReactComponent };